<template>
  <section class="block-cancel-subscription container">
    <div class="columns">
      <div class="column is-6">
        <LsSupportHeader class="block_cancel-title" label="Cancel Service" back-route="support" />

        <LsInfoCard class="info-card">
          <h4>Cannot cancel service</h4>
          <p>
            You have not met our 3 cut minimum requirement. Please
            <RouterLink :to="{ name: 'messageLS' }">contact Support</RouterLink>
            for help with your cancellation request.
          </p>
        </LsInfoCard>

        <LsButton
          class="back"
          text="back"
          track-id="block_subscription_cancellation-back"
          test-id="back_link"
          bg-color="primary"
          @click.native="back"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { LsInfoCard, LsButton } from '@/components/common';
import { LsSupportHeader } from '../components';

export default {
  name: 'BlockCancelSubscriptionView',
  components: {
    LsInfoCard,
    LsButton,
    LsSupportHeader,
  },
  methods: {
    back() {
      this.$router.push({ name: 'support' });
    },
  },
};
</script>

<style lang="scss">
.block-cancel-subscription {
  .block_cancel-title h1 {
    font-weight: lighter;
  }

  .info-card {
    align-items: flex-start;
    flex-direction: column;
    margin: 2rem 0 3rem;
    padding: 2rem 2rem 2rem 4.3rem;

    & > h4 {
      font-size: 1.4rem;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
}
</style>
